import Option from './Option';

export default class ContextOption extends Option {
    static type = 'context';
}